export default {
  destructure: (num) => {
    if (!num) return ["+233", ""];
    const zip = num.substring(0, num.length - 9);
    const phone = `0${num.substring(num.length - 9, num.length)}`;
    return [zip == 0 ? "+233" : zip, phone];
  },

  structure: (zip, phone) => {
    let prefix = zip || "+233";
    let suffix;
    suffix = phone.substring(phone.length - 9, phone.length);
    return `${prefix}${suffix}`;
  },
};
